import React, { createContext, useContext, useState, useEffect } from 'react';
    import { supabase } from '../config/supabase';

    const FeatureFlagContext = createContext();

    export const useFeatureFlags = () => {
        const context = useContext(FeatureFlagContext);
        if (!context) {
            throw new Error('useFeatureFlags must be used within a FeatureFlagProvider');
        }
        return context;
    };

    export const FeatureFlagProvider = ({ children }) => {
        const [features, setFeatures] = useState({});
        const [loading, setLoading] = useState(true);

        useEffect(() => {
            const fetchFeatureFlags = async () => {
                try {
                    const { data, error } = await supabase.from('feature_flags').select('*');
                    if (error) throw error;

                    const flags = data.reduce((acc, flag) => {
                        acc[flag.feature_name] = flag.is_enabled;
                        return acc;
                    }, {});
                    setFeatures(flags);
                } catch (error) {
                    console.error('Error fetching feature flags:', error);
                } finally {
                    setLoading(false);
                }
            };

            fetchFeatureFlags();
        }, []);

        const isEnabled = (featureName) => {
            // Default to false if loading or feature not found
            return !!features[featureName];
        };

        const value = {
            features,
            isEnabled,
            loading,
        };

        return (
            <FeatureFlagContext.Provider value={value}>
                {children}
            </FeatureFlagContext.Provider>
        );
    };